module.exports = __webpack_public_path__ + "media/goodbye.59892a41.mp3";